export function clear() {
  return {
    type: 'GENERIC/CLEAR'
  }
}